<template>
    <div class="d-flex flex-column flex-lg-row mb-3">
        <div class="flex-grow-1">
            <slot/>
        </div>
        <div v-if="$slots.right" class="d-flex flex-md-row gap-2 justify-content-end align-items-center">
            <slot name="right"/>
        </div>
    </div>
</template>

<script>
export default {}
</script>
